import { history } from "../../../_components/_helpers/history";
import {  dataProvider, config } from "../../../studentportal-sdk";
import { utilityAndConfigStore, useAssessment } from "../../store/zustand";

export const Assessment = (props) => {
  // data provider modules
  const { asapceoApi } = dataProvider;

  // app utility and configuration store
  const { loading, setMessage, startLoading, stopALoadingProccess } =
    utilityAndConfigStore((state) => ({
      loading: state.loading,
      setMessage: state.setMessage,
      startLoading: state.startLoading,
      stopALoadingProccess: state.stopALoadingProccess,
    }));

  const {
    assessmentDoc,
    assessmentDocs,
    setAssessments,
    setAssessment,
    assessmentAction,
    setAssessmentAction,
    questionDocs,
    setQuestionDocs,
    timer,
    setTimer,
    assessmentResultDocs,
    setAssessmentResult
  } = useAssessment((state) => ({
    assessmentDoc: state.assessmentDoc,
    assessmentDocs: state.assessmentDocs,
    setAssessments: state.setAssessments,
    setAssessment: state.setAssessment,
    assessmentAction: state.assessmentAction,
    setAssessmentAction: state.setAssessmentAction,
    questionDocs: state.questionDocs,
    setQuestionDocs: state.setQuestionDocs,
    timer: state.timer,
    setTimer: state.setTimer,
    assessmentResultDocs: state.assessmentResultDocs,
    setAssessmentResult: state.assessmentResult
  }));

  const getAllAssessment = () => {
    (async () => {
      // start loading a process
      startLoading({
        internalLoading: true,
      });

      const assessment = await asapceoApi.getAllAssessment();

      assessment.status && setAssessments(assessment.data);

      // stop loading process
      assessment && stopALoadingProccess();
    })();
  };

  const storeAssessmentAction = (store) => {
    localStorage.setItem("assessmentId", store.id);
    setAssessmentAction(store);
  };

  const getassessmentById = (id) => {
    (async () => {
      const assessment = await asapceoApi.getassessmentById(id);
      assessment.status && setAssessment(assessment.data);
    })();
  };

  const addAssessment = (data) => {
    (async () => {
      const assessment = await asapceoApi.addAssessment(data);
      // report occured error
      assessment?.error &&
        setMessage({
          type: "error",
          show: true,
          title: config.constants.authMessage.titleError,
          // description: assessment?.message,
          description: assessment?.message,
          alert: true,
          inLine: true,
        });

      // report success
      assessment?.status &&
        setMessage({
          type: "success",
          show: true,
          title: config.constants.authMessage.titleSuccess,
          // description: assessment?.message,
          description: config.constants.happyReport,
          alert: true,
          inLine: true,
        });
    })();
  };

  const updateAssessment = (data) => {
    (async () => {
      const assessment = await asapceoApi.updateAssessment(data);
      // report occured error
      assessment?.error &&
        setMessage({
          type: "error",
          show: true,
          title: config.constants.authMessage.titleError,
          // description: assessment?.message,
          description: assessment?.message,
          alert: true,
          inLine: true,
        });

      // report success
      assessment?.status &&
        setMessage({
          type: "success",
          show: true,
          title: config.constants.authMessage.titleSuccess,
          // description: assessment?.message,
          description: config.constants.happyReport,
          alert: true,
          inLine: true,
        });
    })();
  };

  const deleteassessmentById = () => {
    (async () => {
      const assessment = await asapceoApi.deleteassessmentById(
        assessmentAction.id
      );

      // report occured error
      assessment?.error &&
        setMessage({
          type: "error",
          show: true,
          title: config.constants.authMessage.titleError,
          // description: assessment?.message,
          description: assessment?.message,
          alert: true,
          inLine: true,
        });

      // report success
      assessment?.status &&
        setMessage({
          type: "success",
          show: true,
          title: config.constants.authMessage.titleSuccess,
          // description: assessment?.message,
          description: config.constants.happyReport,
          alert: true,
          inLine: true,
        });
    })();
  };

  const createQuestion = (data) => {
    (async () => {
      const question = await asapceoApi.createQuestion(data);
      // report occured error
      question?.error &&
        setMessage({
          type: "error",
          show: true,
          title: config.constants.authMessage.titleError,
          // description: question?.message,
          description: question?.message,
          alert: true,
          inLine: true,
        });

      // report success
      question?.status &&
        setMessage({
          type: "success",
          show: true,
          title: config.constants.authMessage.titleSuccess,
          // description: assessment?.message,
          description: config.constants.happyReport,
          alert: true,
          inLine: true,
        });
    })();
  };

  const getAllQuestions =(data) => {
    (async () => {
    const questions = await asapceoApi.getQuestions(data)
    questions.data && setQuestionDocs(questions.data)
  })()
  }

  const enrollForAssessment =(data) => {
    (async () => {
    const questions = await asapceoApi.startAssessment({assessmentId:data.assessmentId})
   questions.data && localStorage.setItem("questions", JSON.stringify(questions.data.questions))
   questions.data && localStorage.setItem("timer", data.timer * 3600)
    questions?.error &&
        setMessage({
          type: "error",
          show: true,
          title: config.constants.authMessage.titleError,
          // description: question?.message,
          description: questions?.message,
          alert: true,
          inLine: true,
        });

      // report success
      questions?.status &&
        setMessage({
          type: "success",
          show: true,
          title: config.constants.authMessage.titleSuccess,
          // description: assessment?.message,
          description: config.constants.happyReport,
          alert: true,
          inLine: true,
        }) 
        
       questions.data && history.push("/viewassessment")
  })()
  }

  const getQuestion =() => {
    (async () => {
      const questionIds = JSON.parse(localStorage.getItem('questions'))
      if(questionIds){
      const allQuestions = await Promise.all(
        questionIds.map(async(questionId) => {
          const question = await asapceoApi.getQuestion(questionId.id)
          return question.data
        })
      )
      setQuestionDocs(allQuestions)
    }
  })()
  }

  const getAssessmentResult =(assessmentId) => {
    (async () => {
    const result = await asapceoApi.getAssessmentResult(assessmentId)
    result.data && localStorage.setItem('assessmentResult', result.data.score)
    // result.data && setAssessmentResult(result.data)
  })()
  }

  const EnrolledAssessment =(userId) => {
    (async () => {
    const result = await asapceoApi.getEnrolledAssessment(userId)
    result.data && setAssessment(result.data)
    // result.data && setAssessmentResult(result.data)
  })()
  }

  const sendAnswer = (data) => {
    (
      async () => {
        const result = await asapceoApi.submitAnswer(data)

        result?.error &&
        setMessage({
          type: "error",
          show: true,
          title: config.constants.authMessage.titleError,
          // description: question?.message,
          description: result?.message,
          alert: true,
          inLine: true,
        });

      // report success
      result?.status &&
        setMessage({
          type: "success",
          show: true,
          title: config.constants.authMessage.titleSuccess,
          description: result?.message,
          // description: config.constants.happyReport,
          alert: true,
          inLine: true,
        }) 
      }
    )()
  }
  return {
    store: {
      assessmentDoc,
      assessmentDocs,
      assessmentAction,
      loading,
      questionDocs,
      timer,
      assessmentResultDocs
    },
    action: {
      addAssessment,
      updateAssessment,
      getAllAssessment,
      getassessmentById,
      setAssessmentAction,
      storeAssessmentAction,
      deleteassessmentById,
      createQuestion,
      getAllQuestions,
      enrollForAssessment,
      setQuestionDocs,
      setTimer,
      getQuestion,
      setAssessmentResult,
      getAssessmentResult,
      EnrolledAssessment,
      sendAnswer
    },
    history,
    ...props,
  };
};
